import { ROLE_PERMISSIONS } from "../apiEndpoint";
import { educationAxios } from "../http/http";

export default function rolesPermissions(useremail,role) {
  return educationAxios.get(
    `${ROLE_PERMISSIONS}?user_email=${useremail}&role=${role}`
  );
}
